import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';

@Component({
    selector: 'rh-login',
    imports: [CommonModule, MatGridListModule, MatCardModule, MatButtonModule],
    templateUrl: './login.component.html',
    styleUrl: `./login.component.scss`
})
export class LoginComponent {
  @Input() errorMessage?: string;
  @Output() loginAction = new EventEmitter();
}
